import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'

const Wrapper = styled.div`
  width: 70px;
  min-height: 70px;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  ${media.xs`
    background: none;
  `}
`

export default class FacebookIcon extends Component {
  render() {
    return(
      <Wrapper>
        <svg
          width="16"
          height="30"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.397.006L11.56 0C7.248 0 4.462 2.859 4.462 7.283v3.358H.603a.603.603 0 0 0-.603.604v4.865c0 .334.27.604.603.604h3.859V28.99c0 .333.27.603.603.603H10.1c.333 0 .603-.27.603-.603V16.714h4.512c.333 0 .603-.27.603-.604l.002-4.865a.604.604 0 0 0-.604-.604h-4.513V7.794c0-1.368.326-2.062 2.109-2.062l2.585-.001c.333 0 .603-.27.603-.604V.61a.604.604 0 0 0-.603-.604z"
            fill="#FFF"
          />
        </svg>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/Footer/FacebookIcon.js